import gql from 'graphql-tag'
import {Constants} from "../../Constants/Constant";

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '{}';
let intermediateCondition = '';
if(cities && cities.length){
    cities.forEach(function(curnt){
        let cityStr = '{address: {_contains: [{city:"'+ curnt.city +'"}]}},'
        intermediateCondition = intermediateCondition + cityStr
    })
    finalCondition = intermediateCondition
}

export const GET_COMPANIES = gql`
  query ($searchFilter: String!){
    company (where: {_and: [{_or: [${finalCondition}] },
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }
    ]}){
      id
      name
      email
      mobile
      gstin
      address
      type
      routes
    }
  }
`
export const GET_SINGLE_COMPANY = gql`
query ($companyId:uuid!){
  company(where: {id: {_eq: $companyId}}) {
    id
    address
    email
    gstin
    mobile
    name
    trucks_aggregate { aggregate {count}}
    drivers_aggregate { aggregate {count}}
    type
    typeByType {id name }
    companyUsers{
      name
      mobile
      role
      email
      id
   }
   }
  contacts (where:{clientid:{_eq: $companyId}}){
      name
      mobile
      role
      email
      id
   }
   orders (where:{clientid:{_eq: $companyId}}){
      id
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      pickupDate
      internalstatus
      externalstatus
   }
}
`
export const GET_COMPANY_DETAIL = gql`
query ($companyId:uuid!){
  clientDetail: company(where: {id: {_eq: $companyId}}) {
    id
    address
    email
    gstin
    mobile
    name
    typeByType {id name }
   }
  contacts (where:{clientid:{_eq: $companyId}}){
      name
      mobile
      role
      email
      id
   }
   users: CompnayUser (where:{clientid:{_eq: $companyId}}){
      name
      mobile
      role
      email
      id
   }
}
`
export const GET_TRANSPORTER_DETAIL = gql`
query getTransporterDetail($companyId:uuid!){
  transporterDetail: company(where: {id: {_eq: $companyId}}) {
    id
    address
    email
    gstin
    mobile
    name
    trucks{ id  platNo capacity}
    drivers{ id  name mobile driverType}
   }
  contacts (where:{clientid:{_eq: $companyId}}){
      name
      mobile
      role
      email
      id
   }
}
`
export const GET_COMPANY_TYPE = gql`
query{
  type {
    id
    name
    type
    parentId
  }
}`

// company(where: {type: {_in: ["17f23eaa-134d-72d4-219c-35b0da7832ae", "0842dd15-1070-60f2-dbf5-c42755494e3a", "3a3248e1-f7a9-1982-1309-f9b6b780af40"]}, _and: {name: {_ilike: $dealerFilter}, _and: {address: {_contains: $filterDealerCity}}}}) {
export const SEARCH_DEALER = gql`
  query company($dealerFilter: String!, $filterDealerCity:jsonb!){
  company(where: {_and: {name: {_ilike: $dealerFilter}, address: {_contains: $filterDealerCity}, isApproved: {_eq: true},
                         type: {_in: ["${Constants.companyType.dealer}","${Constants.companyType.manufacture}","${Constants.companyType.wholesaler}"]} }}) {
    id
    name
    email
    mobile
    address
  }
}
`
export const SEARCH_DROPPINGPARTY = gql`
  query addressbookedcompany($droppingPartyFilter: String!, $filterDroppingCity: jsonb!){
  addressbookedcompany(where: {_and: {name: {_ilike: $droppingPartyFilter},
  address: {_contains: $filterDroppingCity}, isApproved: {_eq: true} }}) {
    id
    name
    email
    mobile
    address
  }
  }
`



// addressbookedcompany(where: {_and: {type: {_in: ["2f71360b-aae2-4a5c-9c57-6b2a68c557a6","3a3248e1-f7a9-1982-1309-f9b6b780af40"]}}, name: {_ilike: $pickupPartyFilter},
//     address: {_contains: $filterpickupPartyCity}}) {
export const SEARCH_PICKUPPARTY = gql`
  query addressbookedcompany($pickupPartyFilter: String!, $filterpickupPartyCity: jsonb!){
  addressbookedcompany(where: {_and: {name: {_ilike: $pickupPartyFilter},address: {_contains: $filterpickupPartyCity}, isApproved: {_eq: true} }}) {
    id
    name
    email
    mobile
    address
  }
  }
`

export const SEARCH_TRANSPORTER = gql`
  query company($transporterFilter: String!){
  company(where: {_and: {type: {_in: ["2f71360b-aae2-4a5c-9c57-6b2a68c557a6"]}}, name: {_ilike: $transporterFilter}, isApproved: {_eq: true}}) {
    id
    name
  }
  }
`
export const GET_TRANSPORTERS = gql`
  query company{
  company(where: {_and: {type: {_in: ["2f71360b-aae2-4a5c-9c57-6b2a68c557a6"]}, isApproved: {_eq: true}}}) {
    id
    name
  }
  }
`
export const GET_ALL_COMPANIES_BY_TYPE = gql`
  query ($searchFilter: String!, $city:jsonb!, $companyTypes:[uuid!], $isApproved:Boolean, $isRejected:Boolean){
    company (where: {_and: [{_or: [${finalCondition}] },{address: {_contains: $city}},{type: {_in: $companyTypes}},{isApproved: {_eq: $isApproved}},{isRejected: {_eq: $isRejected}},
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}},
           {companyUsers: {name: {_ilike: $searchFilter}}},{companyUsers: {mobile: {_ilike: $searchFilter}}},{companyUsers: {email: {_ilike: $searchFilter}}}] }]} ){
      id
      name
      email
      mobile
      gstin
      address
      isApproved
      isRejected
      typeByType{id name}
      preference
      orders_aggregate { aggregate { count } }
    }
  }
`
export const GET_ALL_TRANSPORTERS = gql`
  query transporters($searchFilter: String!, $city:jsonb!, $typeId:uuid!, $isApproved:Boolean, $isRejected:Boolean){
    company (where: {_and: [{_or: [${finalCondition}] },{address: {_contains: $city}},{type: {_eq: $typeId}}, {isApproved: {_eq: $isApproved}},{isRejected: {_eq: $isRejected}},
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }]} ){
      id
      name
      email
      mobile
      gstin
      address
      isApproved
      isRejected
      typeByType{id name}
      orders_aggregate { aggregate { count } }
      truckOrders_aggregate { aggregate { count } }
      trucks_aggregate { aggregate { count } }
      drivers_aggregate { aggregate { count } }
    }
  }
`
export function generate_SEARCH_COMPANY(name){
 return gql`
  query search${name}($search: String, $city: jsonb!){
  ${name+'Arr'}: addressbookedcompany(where: {_and: {name: {_ilike: $search}, address: {_contains: $city}, isApproved: {_eq: true} }}) {
    id
    name
    email
    mobile
    address
  }
  }
`
}
export const SEARCH_CONSIGNEE = gql`
  query searchConsignee($search: String){
  consigneeArr: addressbookedcompany(where: {_and: {name: {_ilike: $search}, isApproved: {_eq: true} }}) {
    id
    name
    email
    mobile
    address
  }
  }
`
export const GET_COMPANY_BY_ID = gql`
query getAddressBookCompanyById($id:uuid!){
  company: addressbookedcompany(where: {id: {_eq: $id}}) {
    id
    name
    address
  }
  }
`
